import apply from './helpers/apply';
import validator from './helpers/validator';
import { emailField } from './validations';
import Notify from 'klicknotify';
import { addAttributeToEmailField, linkSubmitToButton } from './factories';

const filters = [
  addAttributeToEmailField,
  linkSubmitToButton,
];

const validations = [
  emailField,
];

const standard = html => {
  const tests = validator(validations, html);
  if (!tests) {
    Notify.error({
      message: 'Esse não é um formulário de email válido!',
      autoHide: true,
    });
    return '';
  }

  return apply(filters, html);
};

export default standard;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/standard.js
 **/